module.exports = __webpack_public_path__ + "static/media/dianli.ccfc4e45.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageCommercialPassword/dianli.png
// module id = 603
// module chunks = 0